// src/pages/LoginPage.jsx

import React, { useEffect, useState, useCallback } from "react";
import { Password } from "../constant";
import { useNavigate } from "react-router-dom";
import API from "../services/API";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const LoginPage = () => {
  const navigate = useNavigate();
  const [state, setState] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const getToken = useCallback(async () => {
    try {
      const jwt_token = localStorage.getItem("token");
      if (!jwt_token) return;

      const headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
        token: jwt_token,
      };

      const response = await API.get("/schoolStaff/checkToken", { headers });

      if (response?.data?.response_code === 1000) {
        navigate("/dashboard");
      }
    } catch (err) {
      console.error("checkToken error:", err);
    }
  }, [navigate]);

  useEffect(() => {
    getToken();
  }, [getToken]);

  const onChange = (field, event) => {
    setState((prev) => ({ ...prev, [field]: event.target.value }));
  };

  const handleSubmit = async (e) => {
    e?.preventDefault();
    if (loading) return;

    if (!state.email || !state.password) {
      toast.error("Sila masukkan emel dan kata laluan.", { autoClose: 4000 });
      return;
    }

    setLoading(true);

    try {
      const response = await API.post("/schoolStaff/login", {
        email: state.email,
        password: state.password,
      });

      const { data } = response || {};

      if (data?.response_code === 1000) {
        localStorage.setItem("token", data?.data?.token || "");
        localStorage.setItem("full_name", data?.data?.full_name || "");
        localStorage.setItem("school_name", data?.data?.school_name || "");
        localStorage.setItem("role", data?.data?.role || "");
        localStorage.setItem("school_logo_url", data?.data?.logo || "");

        toast.success("Berjaya log masuk.", { autoClose: 1500 });
        navigate("/dashboard");
      } else {
        toast.error(data?.message || "Log masuk gagal.", { autoClose: 5000 });
      }
    } catch (err) {
      const msg =
        err?.response?.data?.message ||
        err?.message ||
        "Tidak dapat menghubungi pelayan.";
      toast.error(msg, { autoClose: 5000 });
    } finally {
      setLoading(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") handleSubmit(e);
  };

  return (
    <>
      <style>{`
        .login-screen {
          min-height: 100vh;
          display: grid;
          grid-template-columns: 1.05fr 0.95fr;
          background: #f8fafc;
          font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
        }

        .login-brand-panel {
          position: relative;
          overflow: hidden;
          padding: 64px;
          color: #fff;
          background:
            radial-gradient(circle at top left, rgba(255,255,255,0.28), transparent 32%),
            linear-gradient(135deg, #8a2387 0%, #e94057 48%, #f27121 100%);
          display: flex;
          flex-direction: column;
          justify-content: space-between;
        }

        .login-brand-panel:before {
          content: "";
          position: absolute;
          width: 520px;
          height: 520px;
          border-radius: 999px;
          background: rgba(255,255,255,0.09);
          right: -180px;
          bottom: -180px;
        }

        .login-brand-panel:after {
          content: "";
          position: absolute;
          width: 260px;
          height: 260px;
          border-radius: 999px;
          border: 1px solid rgba(255,255,255,0.2);
          left: 60px;
          bottom: 120px;
        }

        .brand-top,
        .brand-copy,
        .brand-metrics {
          position: relative;
          z-index: 1;
        }

        .brand-top img {
          height: 82px;
          object-fit: contain;
          margin-bottom: 18px;
        }

        .brand-pill {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 9px 14px;
          border-radius: 999px;
          background: rgba(255,255,255,0.16);
          border: 1px solid rgba(255,255,255,0.2);
          font-size: 12px;
          font-weight: 800;
          letter-spacing: .08em;
          text-transform: uppercase;
        }

        .brand-copy h1 {
          max-width: 620px;
          margin: 0;
          font-size: 54px;
          line-height: 0.98;
          font-weight: 950;
          letter-spacing: -0.055em;
        }

        .brand-copy p {
          max-width: 520px;
          margin-top: 22px;
          font-size: 17px;
          line-height: 1.65;
          color: rgba(255,255,255,0.86);
        }

        .brand-metrics {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 14px;
          max-width: 560px;
        }

        .metric-card {
          padding: 18px;
          border-radius: 22px;
          background: rgba(255,255,255,0.14);
          border: 1px solid rgba(255,255,255,0.18);
          backdrop-filter: blur(10px);
        }

        .metric-card strong {
          display: block;
          font-size: 24px;
          font-weight: 950;
        }

        .metric-card span {
          display: block;
          margin-top: 4px;
          font-size: 12px;
          font-weight: 700;
          color: rgba(255,255,255,0.74);
        }

        .login-form-panel {
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 48px;
          background:
            radial-gradient(circle at top right, rgba(233,64,87,0.08), transparent 34%),
            #f8fafc;
        }

        .login-card-modern {
          width: 100%;
          max-width: 430px;
          padding: 34px;
          border-radius: 30px;
          background: rgba(255,255,255,0.9);
          border: 1px solid rgba(226,232,240,0.9);
          box-shadow: 0 28px 80px rgba(15,23,42,0.12);
        }

        .mobile-logo {
          display: none;
          text-align: center;
          margin-bottom: 20px;
        }

        .mobile-logo img {
          height: 84px;
        }

        .login-card-modern h2 {
          margin: 0;
          color: #0f172a;
          font-size: 30px;
          font-weight: 950;
          letter-spacing: -0.04em;
        }

        .login-card-modern .subtitle {
          margin-top: 8px;
          margin-bottom: 28px;
          color: #64748b;
          font-size: 14px;
          line-height: 1.55;
        }

        .field-group {
          margin-bottom: 18px;
        }

        .field-group label {
          display: block;
          margin-bottom: 8px;
          color: #334155;
          font-size: 13px;
          font-weight: 800;
        }

        .field-group input {
          width: 100%;
          height: 52px;
          padding: 0 15px;
          border-radius: 16px;
          border: 1px solid #e2e8f0;
          background: #fff;
          color: #0f172a;
          font-size: 14px;
          outline: none;
          transition: 0.18s ease;
        }

        .field-group input:focus {
          border-color: #e94057;
          box-shadow: 0 0 0 4px rgba(233,64,87,0.10);
        }

        .login-action {
          width: 100%;
          height: 54px;
          margin-top: 6px;
          border: none;
          border-radius: 17px;
          color: #fff;
          font-size: 14px;
          font-weight: 950;
          letter-spacing: .04em;
          background: linear-gradient(135deg, #e94057, #f27121);
          box-shadow: 0 14px 28px rgba(233,64,87,0.26);
          cursor: pointer;
          transition: 0.18s ease;
        }

        .login-action:hover {
          transform: translateY(-1px);
          box-shadow: 0 18px 34px rgba(233,64,87,0.32);
        }

        .login-action:disabled {
          opacity: 0.7;
          cursor: not-allowed;
          transform: none;
        }

        .forgot-row {
          margin-top: 16px;
          text-align: right;
        }

        .forgot-row button {
          border: none;
          background: transparent;
          color: #e94057;
          font-size: 13px;
          font-weight: 800;
          cursor: pointer;
        }

        .security-note {
          margin-top: 24px;
          padding: 14px;
          border-radius: 18px;
          background: #fff1f3;
          color: #9f1239;
          font-size: 12px;
          font-weight: 700;
          line-height: 1.5;
        }

        @media (max-width: 992px) {
          .login-screen {
            grid-template-columns: 1fr;
          }

          .login-brand-panel {
            display: none;
          }

          .login-form-panel {
            padding: 24px;
          }

          .mobile-logo {
            display: block;
          }

          .login-card-modern {
            padding: 26px;
            border-radius: 26px;
          }
        }
      `}</style>

      <div className="login-screen">
        <section className="login-brand-panel">
          <div className="brand-top">
            <img src="https://imgur.com/kEzgWVd.png" alt="MYSP.AI logo" />
            <div className="brand-pill">School Safety Platform</div>
          </div>

          <div className="brand-copy">
            <h1>Jaringan Keselamatan Anak Anda</h1>
            <p>
              A unified school portal for attendance, student records, parent
              engagement, and operational visibility.
            </p>
          </div>

          <div className="brand-metrics">

          </div>
        </section>

        <section className="login-form-panel">
          <div className="login-card-modern">
            <div className="mobile-logo">
              <img src="https://imgur.com/kEzgWVd.png" alt="MYSP.AI logo" />
            </div>

            <h2>Login School Portal</h2>
            <p className="subtitle">
              Enter your email and password to access your school dashboard.
            </p>

            <form onSubmit={handleSubmit}>
              <div className="field-group">
                <label htmlFor="email">Email</label>
                <input
                  id="email"
                  type="email"
                  value={state.email}
                  onChange={(e) => onChange("email", e)}
                  placeholder="name@school.edu.my"
                  autoComplete="email"
                />
              </div>

              <div className="field-group">
                <label htmlFor="password">{Password}</label>
                <input
                  id="password"
                  type="password"
                  value={state.password}
                  onChange={(e) => onChange("password", e)}
                  onKeyDown={handleKeyDown}
                  placeholder="Enter your password"
                  autoComplete="current-password"
                />
              </div>

              <button className="login-action" type="submit" disabled={loading}>
                {loading ? "SIGNING IN..." : "SIGN IN"}
              </button>
            </form>

            <div className="forgot-row">
              <button type="button" onClick={() => navigate("/forgot-password")}>
                Forgot password?
              </button>
            </div>

            <div className="security-note">
              Secure access for authorised school staff only.
            </div>
          </div>
        </section>

        <ToastContainer
          position="top-right"
          autoClose={4000}
          newestOnTop
          closeOnClick
          pauseOnHover
          draggable
          theme="colored"
        />
      </div>
    </>
  );
};

export default LoginPage;